"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupsQueryFilterBuilder = void 0;
const lodash_1 = require("lodash");
class GroupsQueryFilterBuilder {
    constructor() {
        this.filter = {};
    }
    withTitle(title) {
        if (title) {
            this.filter.lowerCaseTitle = { $contains: title.toLowerCase() };
        }
        return this;
    }
    withPrivacyStatus(status) {
        if (status) {
            this.filter.privacyLevel = status;
        }
        return this;
    }
    withGroupIds(groupIds) {
        if (groupIds) {
            this.filter.groupId = { $in: groupIds };
        }
        return this;
    }
    build() {
        if (!(0, lodash_1.isEmpty)(this.filter)) {
            return this.filter;
        }
    }
}
exports.GroupsQueryFilterBuilder = GroupsQueryFilterBuilder;
//# sourceMappingURL=query-builder.js.map